import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_STATUS } from "../../../config/api";
import { getIpo } from "./getIpo";
import { getIpoSubscriptions } from "./getIpoSubscriptions";

// status: upcoming | open | closed | allotment | cancelled
export const changeIpoStatus = createAsyncThunk(
  "ipos/changeStatus",
  async ({ id, status, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_STATUS(id),
        data: { status },
      });
      toast.success(response?.data?.message || "IPO status updated");
      dispatch(getIpo(id));
      // Moving to "allotment" bulk-flips subscriptions to "processing".
      dispatch(getIpoSubscriptions({ id }));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
